import * as Phaser from "phaser-ce"
import { Scale } from "../../../utils/Scale"
import { MenPos } from "./MenPos"
import { MentalAssets } from "./MentalAssets"

enum Actions {
    REST = "REST",
    HEAD_UP = "HEAD_UP",
    SIT_UP = "SIT_UP",
    IS_UP = "IS_UP",
    DROOL = "DROOL",
    TAIL_WAG = "TAIL_WAG",
}

export class ActionDog {
    dog: Phaser.Sprite
    private readonly dogTail: Phaser.Sprite
    private game: Phaser.Game


    constructor(game: Phaser.Game) {
        this.game = game
        this.dog = game.add.sprite(MenPos.dogX(), MenPos.dogY(), MentalAssets.DOG)
        Scale.scaleSprite(this.dog, 0.75)

        this.dog.animations.add(Actions.REST, [0])
        this.dog.animations.add(Actions.HEAD_UP, [1])
        this.dog.animations.add(Actions.SIT_UP, [3, 4, 2])
        this.dog.animations.add(Actions.IS_UP, [4])
        this.dogTail = game.add.sprite(MenPos.dogTailX(), MenPos.dogTailY(), MentalAssets.DOG_TAIL)
        Scale.scaleSprite(this.dogTail, 0.75)
        this.dogTail.animations.add(Actions.TAIL_WAG, [0, 1, 2, 1])
        this.tailWag()
    }

    rest = () => {
        this.dog.animations.play(Actions.REST)
    }
    headUp = () => {
        this.dog.animations.play(Actions.HEAD_UP)
    }
    sitUp = () => {
        this.dog.animations.play(Actions.SIT_UP, 4)
        this.dogTail.x = MenPos.dogTailX() + Scale.width() * 0.015
    }
    tailWag = () => {
        this.dogTail.animations.stop(Actions.TAIL_WAG)
        this.dogTail.animations.play(Actions.TAIL_WAG, 5, true)
    }
    tailWagFast = () => {
        this.dogTail.animations.stop(Actions.TAIL_WAG)
        this.dogTail.animations.play(Actions.TAIL_WAG, 14, true)
    }
    drool = (loop = false) => {
        const drool = this.game.add.sprite(MenPos.droolX(), MenPos.droolY(), MentalAssets.DROOL)
        Scale.scaleSprite(drool, 0.7)
        drool.animations.add(Actions.DROOL)
        drool.animations.play(Actions.DROOL, 10, loop, true)
    }
}
